import { Directive, ElementRef, HostListener } from '@angular/core';

// this isn't full-proof.  be sure to validate in the backend.   [ Number() || null]
// https://stackoverflow.com/questions/50722368/limit-input-field-to-two-decimal-places-angular-5/55072025

@Directive({
  selector: '[ngbNumbersOnly]'
})
export class NumbersOnlyDirective {
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete']; // , '-'

  constructor(private el: ElementRef) {
  }

  // todo this does not allow ctrl shortcuts (cut, paste, etc)
  // todo this incorrectly allows mouse actions (right click -> paste)
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    let current: string = this.el.nativeElement.value;
    if (current && !String(current).match(this.regex)) {
      const cleaned = current.toString().match(/^-?\d+(?:\.\d{0,2})?/);
      this.el.nativeElement.value = cleaned === null ? '' : Number(cleaned[0]);
    }
  }
}

